
import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

const ContactUs = () => {

    return (
        <main className="flex flex-1 flex-col">
            <Navbar />
            <div className="mx-auto w-full max-w-3xl px-4 text-center sm:px-8">
                <h1 className="page-heading">Contact Us</h1>
                <iframe title="Contact form" className="h-[1761px] w-full border-0" src="https://docs.google.com/forms/d/e/1FAIpQLSc74eY1OzzUSuQDAAdXSbxy_HfYdYEzhdZdEB9b2KsaH_cKXw/viewform?embedded=true">Loading…</iframe>
            </div>
            <Footer />
        </main>
    );
};

export default ContactUs;
